import React from "react";
import { Iprops } from "./productrecommendationsinterface";
import ProductRecommendation from "./productrecommendations";

const ProductRecommendationsContainer = (props: Iprops) => {
    return (<ProductRecommendation {...props}/>)
};

export default ProductRecommendationsContainer;